/* eslint-disable no-console */
const _ = require("lodash");

/**
 * Helper logging functions for the dev menu.
 */

const TITLE_STYLE = "font-size: 1.5em; font-weight: bold;";

/* Display a successful text message in the dev menu. */
const notifyOfLogging = id => {
	const notificationDiv = document.querySelector(`#${id}`);
	if (notificationDiv) {
		notificationDiv.textContent = "Logged to the browser console";
		setTimeout(() => {
			notificationDiv.textContent = "";
		}, 5000);
	}
};

/* Log the vault action history to the console. */
const logVaultActionHistory = () => {
	console.log("%cVault action history", TITLE_STYLE);
	const history = _.map(window?.DEBUG_ACTION_HISTORY, historyItem => {
		const row = {
			actionType: historyItem.action.type,
			...historyItem,
			modifyingHooks: historyItem.modifyingHooks?.join(","),
			customEvents: historyItem.customEvents?.map(e => e.name)?.join(","),
		};
		return row;
	});
	console.table(history, [
		"actionType",
		"dispatchPerfNow",
		"updatePerfNow",
		"emitPerfNow",
		"modifyingHooks",
		"customEvents",
	]);
	notifyOfLogging("vaultActionHistoryLoggingNotification");
};

/* Log the current vault state to the console. */
const logVaultState = vaultState => {
	console.log("%cCurrent vault state", TITLE_STYLE);
	console.log(vaultState);
	notifyOfLogging("vaultStateLoggingNotification");
};

/* Log the vault action type mapping to the console. */
const logVaultActionTypes = () => {
	console.log("%cVault action type mapping", TITLE_STYLE);
	console.log(window?.DEBUG_AT);
	notifyOfLogging("vaultActionMappingLoggingNotification");
};

/*
 * Log the current results to the console.
 *
 * @param {Object} props - A props object containing the vault state and userID.
 */
const logCurrentResults = props => {
	const blocksData = _.get(props, [
		"vaultState",
		"userData",
		props.userID,
		"blocks",
	]);
	const blocksWithResults = _.filter(_.values(blocksData), block => {
		return !_.isNull(block.currentResult);
	});
	console.log("%cCurrent Results", TITLE_STYLE);
	console.log(blocksWithResults);
	notifyOfLogging("currentResultLoggingNotification");
};

module.exports = {
	logVaultActionHistory,
	logVaultState,
	logVaultActionTypes,
	logCurrentResults,
};
